import { initMap, initView } from '@/services/map-services/map-service';
import '@/services/map-services/ol-map-extensions';
export var LayerDetailsMapMutationCodes;
(function (LayerDetailsMapMutationCodes) {
    LayerDetailsMapMutationCodes["SELECT_BASEMAP"] = "SELECT_BASEMAP";
    LayerDetailsMapMutationCodes["SET_MAP_OBJECT"] = "SET_MAP_OBJECT";
    LayerDetailsMapMutationCodes["ADD_MAP_LAYER"] = "ADD_MAP_LAYER";
    LayerDetailsMapMutationCodes["ZOOM_TO_EXTENT"] = "ZOOM_TO_EXTENT";
})(LayerDetailsMapMutationCodes || (LayerDetailsMapMutationCodes = {}));
export const mutations = {
    [LayerDetailsMapMutationCodes.SELECT_BASEMAP](state, payload) {
        const currentBasemap = state.basemaps.find((layer) => layer.get('basemap') && layer.getVisible());
        if (currentBasemap !== undefined) {
            currentBasemap.setVisible(false);
        }
        payload.setVisible(true);
    },
    [LayerDetailsMapMutationCodes.SET_MAP_OBJECT](state, payload) {
        state.ol.view = initView();
        state.ol.home.center = state.ol.view.getCenter();
        state.ol.home.zoom = state.ol.view.getZoom();
        state.ol.map = initMap('details-map', state.ol.view, payload);
        state.ol.map.addLayer(state.ol.selectionLayer);
        let currZoom = state.ol.map.getView().getZoom();
        state.ol.map.on('moveend', function (e) {
            // @ts-ignore
            const newZoom = state.ol.map.getView().getZoom();
            if (currZoom !== newZoom) {
                console.log('zoom end, new zoom: ' + newZoom);
                currZoom = newZoom;
            }
        });
    },
    [LayerDetailsMapMutationCodes.ADD_MAP_LAYER](state, payload) {
        state.ol.map?.addLayer(payload);
        state.layer = payload;
    },
    [LayerDetailsMapMutationCodes.ZOOM_TO_EXTENT](state, payload) {
        state.ol.view?.fit(payload);
    },
};
